<template>
<v-content>
  <v-dialog v-model="deletedialog" persistent width="550">
    <v-card >
      <v-card-text class="text-center">
      <div><v-icon class="mt-5" color="red" x-large>mdi-alert</v-icon></div>
        <span class="title">マイ機器を削除しますか？</span>
        </v-card-text>
        <v-card outlined class="mx-10 px-10 mb-5">
            <v-card-text>
              マイ機器名：{{ Name }} <br>
              <span v-show="CustomerMachineID">マイ機器ID：{{ CustomerMachineID }}</span>
              <span v-show="!CustomerMachineID">マイ機器ID：なし</span>
            </v-card-text>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>

        <v-row dense class="mb-5">
          <v-col cols="8" align-self="center">
            <v-btn
              color="grey darken-4"
              outlined
              rounded
              elevation="2"
              @click="close()"
              class="mr-2"
            >
              キャンセル
            </v-btn>
            <v-btn
              color="red darken-1 white--text"
              rounded
              @click="deleteMachine()"
            >
              削除する
            </v-btn>
          </v-col>
        </v-row>
       </v-card-actions>
     </v-card>
   </v-dialog>

   <v-dialog
      v-model="confirmdialog"
      persistent
      max-width="550"
    >
      <v-card>
         <v-card-text class="text-center">
           <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          削除されました。<br>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="confirmDialog()"
            class="white--text mb-5"
          >
            マイ機器一覧へ戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isFailured"
      persistent
      max-width="550"
    >
      <v-card>
         <v-card-text class="text-center">
           <div><v-icon class="my-5" color="red" x-large>mdi-alert</v-icon></div>
          削除時にエラーが発生しました。<br>
          時間を置いて再度削除してください。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            block
            @click="confirmDialog()"
            class="white--text mb-5"
          >
            マイ機器一覧へ戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-content>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { deleteMachine } from "../graphql/mutations"

export default {
  props:[
      "machineid",
      "Name",
      "CustomerMachineID",
      ],
  data() {
    return {
      deletedialog: false,
      confirmdialog: false,
      isFailured: false
    };
  },
  methods: {
    deleteMachine: async function () {
        const deleteinfo = {
        id: this.machineid,
        }
        try {
            await API.graphql(graphqlOperation(deleteMachine, {input: deleteinfo}))
            console.log('success', "delete")
            this.deletedialog = false;
            this.confirmdialog = true
            // this.$router.push('/mymachinelist')
        } catch (error) {
            console.log('error: ', error)
            this.deletedialog = false;
            this.isFailured = true
        }
    },
    open() {
      this.deletedialog = true;
    },
    close() {
      this.deletedialog = false;
    },
    confirmDialog() {
      this.$router.push('/mymachinelist')
    }

  }
}
</script>
